import { useState, useCallback } from 'react';

export const useAccordion = ({ defaultOpenIds = [], allowMultiple, onChange }) => {
  const [openIds, setOpenIds] = useState(() => new Set(defaultOpenIds));

  const handleToggle = useCallback(
    (id) => {
      setOpenIds((prev) => {
        const next = new Set(prev);
        if (next.has(id)) {
          next.delete(id);
        } else if (allowMultiple) {
          next.add(id);
        } else {
          next.clear();
          next.add(id);
        }
        onChange?.(Array.from(next));
        return next;
      });
    },
    [allowMultiple, onChange],
  );

  return {
    openIds,
    handleToggle,
  };
};
